import { ITimeBlockListing } from "../../../entities-generated/models/time-block/time-block-listing";

export interface IAssessmentSchedulerFormDataModel
{
  isRescheduling: boolean;
  timeBlocks: ITimeBlockListing[];
}

export class AssessmentSchedulerFormDataModel implements IAssessmentSchedulerFormDataModel
{
  constructor(public isRescheduling: boolean, public timeBlocks: ITimeBlockListing[]) {}
}